<template>
<div id="container" class="top_home ihlp-width-100">
    <div class="main ihlp-width-100">
        <div class="layout-content ihlp-width-100">
            <router-view v-if="isRouterAlive" :key="activeDate"/>
        </div>
    </div>
</div>
</template>

<script> 
import { mapGetters, mapState } from "vuex";
export default {
  components: { },
  name: "Layout_Top_Left",
  data() {
    return { 
      activeDate: 1
    };
  },
  created() { 
  },
  //初始化后调用
  mounted: function() { 
  },
  computed: {
    ...mapGetters({
      isRouterAlive: "base/getIsRouterAlive"
    })
  },
  methods: { 
    
  }
};
</script>




// WEBPACK FOOTER //
// src/layout/Layout_top_home.vue